import React, { useState } from 'react';
import ImageModal from './ImageModal';

const BlogImage = ({
  src,
  alt,
  caption,
  className = '',
  size = 'icon', // Options: 'icon', 'small', 'medium', 'large', 'full'
  center = true,
  rounded = true,
  shadow = true,
  lightbox = true
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  // Responsive Tailwind-Klassen pro Größe
  const sizeClassMap = {
    icon: 'max-w-[60px]',
    small: 'max-w-xs',          // ~20rem
    medium: 'max-w-md',         // ~28rem
    large: 'max-w-2xl md:max-w-3xl',  // auf kleinen Bildschirmen kleiner
    full: 'w-full max-w-full'
  };

  const sizeClass = sizeClassMap[size] || sizeClassMap.medium;
  const centerClass = center ? 'mx-auto' : '';
  const roundedClass = rounded ? 'rounded-md' : '';
  const shadowClass = shadow ? 'shadow-sm hover:shadow-md transition-shadow' : '';
  const cursorClass = lightbox ? 'cursor-pointer' : '';

  const handleImageClick = () => {
    if (lightbox) setModalOpen(true);
  };

  return (
    <>
      <figure className={`image-container my-6 ${center ? 'text-center' : ''} ${className}`}>
        <img 
          src={src} 
          alt={alt} 
          onClick={handleImageClick}
          title={lightbox ? "Zum Vergrößern klicken" : ""}
          loading="lazy"
          className={`h-auto block ${sizeClass} ${centerClass} ${roundedClass} ${shadowClass} ${cursorClass}`} 
        />
        {caption && (
          <figcaption className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            {caption}
          </figcaption>
        )}
      </figure>

      <ImageModal 
        src={src}
        alt={alt}
        caption={caption}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default BlogImage;
